import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Container, Wrapper } from 'src/components/Layout';
import { Svg } from 'src/components/Svg/Svg';
import { SvgIconNames } from 'src/components/Svg/icons-types';

import { useStoreConfig } from '../AppShell/ConfigProvider';

import classes from './Usps.scss';
import { parseUspCmsBlock } from './parse-usp-cms-block';

type Props = Record<string, unknown>;

export const Usps: React.FC<Props> = () => {
    const { cmsBlocks } = useStoreConfig();

    const [slideIndex, setSlideIndex] = useState(0);
    const data = parseUspCmsBlock(cmsBlocks.uspBanner);

    const totalCount = data.length;
    const position = (slideIndex * 100) / totalCount;

    return (
        <Wrapper
            className={classes.usp}
            bg="grey-light"
            element="section"
            role="complementary"
            aria-label="Woodies unique selling points"
        >
            <Container className={classes.uspContainer}>
                <ul className={classes.uspList} style={{ transform: `translateX(-${position}%)` }}>
                    {data.map((item, index) => {
                        return (
                            <li key={index} className={classes.uspItem}>
                                <Link to={item.link} className={classes.uspNoDecoration}>
                                    {item.icon && (
                                        <>
                                            <figure className={classes.uspItemIcon}>
                                                <Svg name={item.icon as SvgIconNames} aria-hidden={true} />
                                            </figure>
                                            <span>
                                                <b>{item.title}</b> {item.description}
                                            </span>
                                        </>
                                    )}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
                <button
                    disabled={slideIndex === 0}
                    onClick={() => {
                        setSlideIndex(slideIndex - 1);
                    }}
                    className={classes.uspPrev}
                    type="button"
                    aria-label="Previous item"
                >
                    <Svg name="arrow-left" aria-hidden={true} />
                </button>

                <button
                    disabled={slideIndex === totalCount - 1}
                    onClick={() => {
                        setSlideIndex(slideIndex + 1);
                    }}
                    className={classes.uspNext}
                    type="button"
                    aria-label="Next item"
                >
                    <Svg name="arrow-right" aria-hidden={true} />
                </button>
            </Container>
        </Wrapper>
    );
};
